import React, { useState } from 'react'
import { I18n } from 'react-redux-i18n'
import { useSelector, useDispatch } from 'react-redux'

import { createProcessCategory, updateProcessCategory } from 'redux/smartchat/header/actions'
import ModalWrapper from 'components/ModalWrapper'
import { Text, ColorPicker } from 'components/SmartChatView/Fields'

const CategoryModal = ({ isOpen, toggle, mode, processType, categoryId }) => {
  const { categoriesList, modalLoading, modalError } = useSelector(store => store.smartchatHeader)
  const dispatch = useDispatch()
  const category = categoryId && categoriesList.find(category => category._id === categoryId)
  const [categoryName, setCategoryName] = useState(category?.name || '')
  const [categoryColor, setCategoryColor] = useState(category?.color || '#f4f4f4')

  const handleSave = () => {
    if (mode === 'add') {
      dispatch(createProcessCategory({
        category: {
          name: categoryName,
          color: categoryColor,
          order: categoriesList.length ? Math.max(...categoriesList.map(category => category.order)) + 1 : 1,
          type: processType
        },
        onFinish: toggle
      }))
    }

    if (mode === 'update') {
      dispatch(updateProcessCategory({
        categoryId,
        category: {
          ...category,
          name: categoryName,
          color: categoryColor
        },
        onFinish: toggle
      }))
    }
  }

  return (
    <ModalWrapper
      isOpen={isOpen}
      toggle={toggle}
      header={I18n.t(`smartchat_category_header_${mode}`)}
      legend={I18n.t(`smartchat_category_legend_${mode}`)}
      eventBtnTxt={I18n.t(`dashboard_${mode}-category`)}
      eventBtn={handleSave}
      cancelBtnTxt={I18n.t('dashboard_cancel')}
      cancelBtn={toggle}
      isSubmitting={modalLoading}
      error={modalError && I18n.t(modalError.message)}
      contentClassName='smartchat-modal'
      body={
        <div className='modal-content modal-content--spaced'>
          <Text
            isRequired
            label={I18n.t('dashboard_name')}
            placeholder={I18n.t('dashboard_example_welcome')}
            value={categoryName}
            onChange={setCategoryName}
          />
          <ColorPicker
            isRequired
            label={I18n.t('dashboard_color')}
            value={categoryColor}
            onChange={setCategoryColor}
          />
        </div>
      }
    />
  )
}

export default CategoryModal
